import { useState } from 'react'
import { MapPin } from 'lucide-react'
import { FACILITY_AREAS, type FacilityArea } from '../../lib/services/survey'

interface AreaSelectorProps {
  value: FacilityArea | null
  onChange: (area: FacilityArea) => void
  /** Show as compact chip row instead of dropdown */
  variant?: 'dropdown' | 'chips'
}

export function AreaSelector({ value, onChange, variant = 'dropdown' }: AreaSelectorProps) {
  const [isOpen, setIsOpen] = useState(false)

  if (variant === 'chips') {
    return (
      <div className="flex flex-wrap gap-1.5">
        {FACILITY_AREAS.map((area) => (
          <button
            key={area}
            type="button"
            onClick={() => onChange(area)}
            className={area === value ? 'tab-chip-active' : 'tab-chip'}
          >
            {area}
          </button>
        ))}
      </div>
    )
  }

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-left focus:border-[var(--brand-primary)] focus:outline-none focus:ring-2 focus:ring-blue-100"
      >
        <MapPin size={14} className="text-slate-400" />
        <span className={value ? 'text-slate-900' : 'text-slate-400'}>
          {value ?? 'Select area…'}
        </span>
      </button>
      {isOpen && (
        <div className="absolute z-20 mt-1 w-full max-h-60 overflow-y-auto rounded-lg border border-slate-200 bg-white shadow-lg">
          {FACILITY_AREAS.map((area) => (
            <button
              key={area}
              type="button"
              onClick={() => { onChange(area); setIsOpen(false) }}
              className={`block w-full text-left px-3 py-2 text-sm hover:bg-slate-50 ${
                area === value ? 'bg-blue-50 font-semibold text-[var(--brand-primary)]' : 'text-slate-700'
              }`}
            >
              {area}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
